import { getContextType } from '../contextManager';
import vuePageType from './vuePageType';

export default function (): any {
    const context = getContextType();
    if (context.name === 'vue') {
        return vuePageType(context.route);
    }
    return {};
}
